<template>
  <div>
    <v-container
      fluid
      class="pa-0 info-drawer"
      :class="{
        'white':isbgWhite,
        'pa-0': true,
        'info-drawer': true
      }"
    >
      <div class="pa-6">
        <div v-if="$store.state.ui.drawer.right.tab == null">
          <div class="d-flex justify-space-between align center mb-1">
            <h2 v-if="$store.state.ui.drawer.right.request">
              Edit Custom Field
            </h2>
            <h2 v-else>
              Add Custom Field
            </h2>
            <v-btn
              icon
              v-track="'close-custom-fields-drawer'"
              @click.stop="$store.commit('ui/drawer.right.toggle')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-form ref="form">
          <v-text-field
            :class="responsive.margin"
            class="pt-6"
            v-model.trim="editForm.field_name"
            label="Field Name*"
            required
            validate-on-blur
            :rules="nameRules"
            outlined
            />
            <v-select
            id="form-type"
            v-track="'form-type'"
            v-model="editForm.field_type"
            class="pt-4"
            item-text="name"
            item-value="value"
            :items="items"
            label="Field Type*"
            :menu-props="{ offsetY: true }"
            outlined
            hint="You cannot change Field Type once this custom field is created."
            persistent-hint
            @change = setBoolean()
            :disabled = "$store.state.ui.drawer.right.request? true : false"
            />
            <v-select
              id="edit-form-type-boolean"
              v-track="'edit-form-type-boolean'"
              v-if= "editForm.field_type == 'boolean'"
              v-model="editForm.default_value"
              class="pt-6"
              item-text="name"
              item-value="value"
              label="Default Value"
              :menu-props="{ offsetY: true }"
              :items="itemsBoolean"
              outlined
            />
            <v-text-field
            v-if= "editForm.field_type !== 'boolean' && editForm.field_type !== 'datetime'"
            class="pt-6"
            :class="responsive.margin"
            :rules="editForm.field_type === 'integer'?defaultFieldRules: []"
            v-model="editForm.default_value"
            label="Default Value"
            outlined
            />
            <v-menu
                id="edit-form-type-datetime"
                v-track="'edit-form-type-datetime'"
                ref="dateMenu"
                v-if= "editForm.field_type === 'datetime'"
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                :nudge-top="20"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="pt-6 field-date-selected"
                    :class="responsive.margin"
                    v-model="editForm.default_value"
                    label="Select Date"
                    append-icon="event"
                    readonly
                    outlined
                    persistent-hint
                    v-on="on"
                    clearable
                    @click:clear="date=null"
                    @click:append="dateMenu = true"
                  />
                </template>
                <v-date-picker
                  id="date-picker"
                  v-track="'date-picker'"
                  v-model="date"
                  :show-current="currentDate"
                  no-title
                  width="290"
                  class="mt-0"
                  @change="editForm.default_value=date;dateMenu = false"
                />
              </v-menu>

            <v-text-field
            class="pt-4"
            :class="responsive.margin"
            v-model="editForm.display_name"
            label="Display Name"
            outlined
            hint="This will be shown as the field’s name"
            persistent-hint
            />
            <v-text-field
            class="pt-6 pb-4"
            :class="responsive.margin"
            v-model="editForm.description"
            label="Description"
            outlined
            />
            <div class="d-flex justify-space-between">
              <div>
                Add to the Edit Profile Page 
                <v-tooltip
                top
                max-width="400"
                color="rgba(0, 0, 0, 0.9)"
                >
                  <template v-slot:activator="{ on }">                
                    <v-icon
                      v-on="on"
                    >
                    mdi-information-outline
                    </v-icon>
                  </template>
              <span class="caption" attach>Your Edit Profile Page allows contacts to update the custom fields, this page can be linked from your footer or an email content.</span>
            </v-tooltip>
              </div>              
              <div class="mt-n5">
                <v-switch
                  id="add-to-profile"
                  v-track="'add-to-profile'"
                  align="right"
                  v-model="editForm.addToProfilePage"
                  color="#03B6FC"
                  hint=""
                  persistent-hint
                  />
              </div>
            </div>
            <div class="div-caption pb-8 mt-n5">
            Enabling this feature will display this Custom Field data on the Edit Profile page, visible to your contacts.
            </div>
            </v-form>
          </div>          
        <div v-else>
          <div class="d-flex justify-space-between align center mb-1">
            <h2>
              Edit Default Field
            </h2>
            <v-btn
              v-track="'close-edit-default-fields-drawer'"
              icon
              @click.stop="$store.commit('ui/drawer.right.toggle')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-text-field
            class="pt-6"
            :class="responsive.margin"
            v-model="firstName"
            label="First Name"
            outlined
          />
          <v-text-field
            class="pt-6"
            :class="responsive.margin"
            v-model="lastName"
            label="Last Name"
            outlined
          />
          <v-tooltip
            v-if="this.baseUrl.includes('app')"
            top
            color="rgba(0, 0, 0, 0.9)"
            :nudge-bottom="30"
            :nudge-left="100"
            >
              <template v-slot:activator="{ on }">
                <div v-on="on">
                <v-text-field
                  disabled
                  class="pt-6"
                  v-model="phone"
                  label="Phone"
                  outlined
                />
                </div>
              </template>
              <span>Phone Number cannot be edited</span>
          </v-tooltip>
          <v-tooltip
            v-if="this.baseUrl.includes('app')"
            top
            color="rgba(0, 0, 0, 0.9)"
            :nudge-bottom="30"
            :nudge-left="140"
            >
              <template v-slot:activator="{ on }">
                <div v-on="on">
                <v-text-field
                  disabled
                  class="pt-6"
                  v-model="fax"
                  label="Fax"
                  outlined
                />
                </div>
              </template>
              <span>Fax cannot be edited</span>
          </v-tooltip>
        </div>
        <v-btn
          dark
          :loading="loading"
          v-track="'save-fields'"
          @click.stop="saveFields()"
        >
          SAVE
        </v-btn>
      </div>
    </v-container>
  </div>
</template>
  <script>
  import { $fields } from '@/services'
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'
  export default {
    mixins: [validationMixin],
    props:{
      isbgWhite:{type:Boolean,default:false},
      isDialog:{type:Boolean,default:false}
    },
    data () {
      return {
      items: [
      {
        name: 'String',
        value: 'string'
      },
      {
        name: 'Integer',
        value: 'integer'
      },
      {
        name: 'Boolean',
        value: 'boolean'
      },
      {
        name: 'Datetime',
        value: 'datetime'
      },
      {
        name: 'Text',
        value: 'text'
      },
      {
        name: 'Float',
        value: 'float'
      }
      ],
      itemsBoolean:[
        {
          name: 'True',
          value: '1'
        },
        {
          name: 'False',
          value: '0'
        }
       ],
       nameRules: [
          v => !!v || 'Name is required',
          v => !v || !!v.trim() || 'Name cannot be blank'],
        defaultFieldRules: [
          v => !!v || 'Default value is not an integer',
        ],
        selectedCustomFieldData: [],
        firstName : '',
        lastName : '',
        phone: '',
        fax: '',
        baseUrl: '',
        editForm: {
        field_name: '',
        field_type: 'string',
        default_value: '',
        display_name: '',
        description: '',
        addToProfilePage: false,
        },
        dateMenu:false,
        date:null,
        loading: false,
        currentDate: null
      }
    },
    mounted () {
      this.currentDate = this.$options.filters.formatDateTZ(new Date(), 'YYYY-MM-DD');
      this.baseUrl = this.$config.RAILS_BASE_URL
      if(this.$store.state.ui.drawer.right.request) {
        this.editCustomField()
      }
      this.getDefaultFieldsData()
    },
    validations: {
      name: { required },
    },
    computed: {
      responsive(){
        return{
          wrapper:!this.isDialog?'px-12 mx-12':'',
          margin:!this.isDialog?'mr-12 pr-12':'',
          field:!this.isDialog?'mr-8 pr-8':'',
        }
      }
    },
    methods: {
      setBoolean (){
        if(this.editForm.field_type == 'boolean')
          this.editForm.default_value = '1'
        else if(this.editForm.field_type == 'datetime'){
            this.editForm.default_value = this.$options.filters.formatDateTZ(new Date(), 'YYYY-MM-DD');
            this.date = this.$options.filters.formatDateTZ(new Date(), 'YYYY-MM-DD');
        }
        else
        this.editForm.default_value = ''
      },
      getDefaultFieldsData (){
        $fields.fetchDefaultFields().then(response => {
          this.firstName = response.data.data.account.first_name
          this.lastName = response.data.data.account.last_name
          }).catch(error => {
          console.error('Error', error)
        })
      },
      editCustomField (){
        $fields.editCustomFieldData(this.$store.state.ui.drawer.right.request).then(response => {
                                   this.selectedCustomFieldData = response.data.data
                                   this.getCustomFieldsData()
                                 }).catch(error => {
            console.error('Error', error)
          })
      },
      getCustomFieldsData(){
        this.editForm.field_name = this.selectedCustomFieldData.name;
        this.editForm.field_type = this.selectedCustomFieldData.field_type;
        this.editForm.default_value = this.selectedCustomFieldData.default_value;
        this.editForm.display_name = this.selectedCustomFieldData.display_name;
        this.editForm.description = this.selectedCustomFieldData.description;
        this.editForm.addToProfilePage = this.selectedCustomFieldData.add_to_profile_page;
        this.date = this.isDate(this.selectedCustomFieldData.default_value)?this.selectedCustomFieldData.default_value
                    :this.$options.filters.formatDateTZ(new Date(), 'YYYY-MM-DD');
      },
       isDate(dateStr) {
        return !isNaN(new Date(dateStr).getDate());
      },
      saveFields()
      {
        if(this.$store.state.ui.drawer.right.tab == null)
        if (!this.$refs.form.validate()) return
        this.loading = true;
        if(this.$store.state.ui.drawer.right.tab == null){
          let custom_field = {
            name : this.editForm.field_name,
            field_type : this.editForm.field_type,
            default_value : this.editForm.default_value,
            display_name : this.editForm.display_name,
            description : this.editForm.description,
            add_to_profile_page : this.editForm.addToProfilePage,
          }
          let params = { custom_field }
          if(this.$store.state.ui.drawer.right.request){
            const customFieldId = this.$store.state.ui.drawer.right.request
            $fields.editCustomField(customFieldId , params).then(response=>{
              if(response.status === 200){
                if (this.isDialog) return this.closeDrawer()
                this.$store.commit('ui/snackbar', { message: "Custom Field updated successfully", type: 'success', timeout: 3000 })
                this.$store.commit('ui/drawer.right', {
                show: false,
                component: null,
                response: { checkUpdateInfo: true },
                })
              }
            }).catch(err => {
              console.log("Error :",err.response.data);
            }).finally(() => {
              this.loading = false
            })
          }
          else{
            $fields.createCustomField(params).then(response=>{
              if(response.status === 201){
                if (this.isDialog) return this.closeDrawer(response.data)
                this.$store.commit('ui/snackbar', { message: "Custom Field created successfully", type: 'success', timeout: 3000 })
                this.$store.commit('ui/drawer.right', {
                show: false,
                component: null,
                response: { checkUpdateInfo: true },
                })
              }
            }).catch(err => {
              console.log("Error :",err.response.data);
            }).finally(() => {
              this.loading = false
            })
          }
        }
        else {
          let account = {
          first_name : this.firstName,
          last_name : this.lastName,
          }
          let params = { account }
          $fields.editDefaultField(params).then(response=>{
            if(response.status === 200){
              this.$store.commit('ui/snackbar', { message: "Default Field updated successfully", type: 'success', timeout: 3000 })
              this.$store.commit('ui/drawer.right', {
                show: false,
                component: null,
                response: { checkUpdateInfo: true },
                
                })
            }
          }).catch(err => {
            console.log("Error :",err.response.data);
          }).finally(() => {
            this.loading = false
          })
        }
      },
      closeDrawer(data=null){
        this.$emit("close-drawer",data)
      },
    }
  }
  </script>
  <style scoped>
  .div-caption{
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
  }
  </style>
  <style lang="scss">
  .info-drawer {
    .field-date-selected{
      label.v-label.v-label--active.theme--light {
      background-color: #fafafa !important;
      padding-right: 2px !important;
      }
    }
  }
  </style>